import React from 'react';
import OrganizerLogo from './OrganizerLogo';
import { useSettings } from '../lib/usePublicData';

const PILLS = ['muziek', 'familie', 'beleving', 'gratis'];

export const About = () => {
    const { data: settings } = useSettings();
    const organizerLogoUrl = settings?.organizer_logo_url || '';
    const executorLogoUrl = settings?.executor_logo_url || '';

    return (
        <section
            id="over"
            data-testid="about-section"
            className="relative bg-vakjes py-16 sm:py-24"
        >
            <div className="mx-auto max-w-5xl px-5 sm:px-8">
                <article className="bg-cream/95 backdrop-blur-sm border-2 border-[var(--green)] rounded-[32px] p-8 sm:p-14 shadow-[0_6px_0_var(--green-dark)]">
                    <h2
                        data-testid="about-title"
                        className="zz-outline-title font-display text-center"
                        style={{ fontSize: 'clamp(2rem, 6vw, 3.75rem)' }}
                    >
                        OVER ZOTTE ZOMER
                    </h2>

                    <div
                        data-testid="about-body"
                        className="mt-8 text-base sm:text-lg leading-relaxed text-[var(--green-dark)] max-w-3xl mx-auto space-y-5"
                    >
                        <p>
                            Bright Events en Stad Ronse slaan de handen in elkaar voor de organisatie van Zotte Zomer:
                            een gloednieuw festivalconcept waarbij muziek, beleving en familieplezier centraal staan.
                        </p>
                        <p>
                            Verspreid over drie zomerse dagen strijkt het festival neer op de mooiste locaties die Ronse
                            te bieden heeft: de Stadstuin, de Kleine Markt en de Grote Markt. Elke locatie krijgt zijn
                            eigen sfeer en karakter, wat zorgt voor een unieke totaalervaring voor bezoekers van alle
                            leeftijden.
                        </p>
                        <p>
                            Met een indrukwekkende line-up en een uitgebreid aanbod aan animatie wil Zotte Zomer een
                            toegankelijk en verbindend evenement zijn waar gezinnen, vrienden en muziekliefhebbers samen
                            kunnen genieten. Bovendien zijn alle festivaldagen volledig gratis, zodat iedereen de kans
                            krijgt om deze bijzondere momenten mee te beleven.
                        </p>
                    </div>

                    <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                        {PILLS.map((p, i) => (
                            <span
                                key={p}
                                data-testid={`about-pill-${p}`}
                                className="zz-pill"
                                style={{
                                    backgroundColor: ['var(--pink)', 'var(--mint)', 'var(--yellow)', 'var(--lilac)'][i % 4],
                                }}
                            >
                                {p}
                            </span>
                        ))}
                    </div>

                    {/* Organizer hierarchy card — Bright Events hoofdorganisator (groter), Stad Ronse met de steun van (kleiner) */}
                    <div
                        data-testid="about-organizer-card"
                        className="mt-12 sm:mt-14 bg-[var(--lilac)]/60 border border-[var(--green)]/40 rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10"
                    >
                        <div className="flex flex-col items-center gap-2 text-center">
                            <span className="font-display text-[10px] sm:text-xs uppercase tracking-[0.18em] text-[var(--green-dark)]/70">
                                Hoofdorganisator
                            </span>
                            <OrganizerLogo url={executorLogoUrl} variant="bright" size="lg" testId="about-org-bright" />
                        </div>
                        <span className="hidden sm:inline-block w-px h-12 bg-[var(--green)]/30" aria-hidden="true" />
                        <div className="flex flex-col items-center gap-2 text-center">
                            <span className="font-display text-[10px] sm:text-xs uppercase tracking-[0.18em] text-[var(--green-dark)]/70">
                                Met de steun van
                            </span>
                            <OrganizerLogo url={organizerLogoUrl} variant="stad" size="md" testId="about-org-stad" />
                        </div>
                    </div>
                </article>
            </div>
        </section>
    );
};

export default About;
